import fromRefinementFilter from './fromRefinementFilter';
import { DATE_REFINEMENT } from 'customer-data-filters-ui/converters/objectSeg/constants/constants';
const tryAddRefinement = (operator, field, filter) => {
  const refinement = fromRefinementFilter(field, filter);
  return refinement ? operator.set(DATE_REFINEMENT, refinement) : operator;
};
const fromPrivacyConsentOperation = (Operator, field, filter) => {
  const operator = Operator.of(field, filter.privacyName);
  return tryAddRefinement(operator, field, filter);
};
export { fromPrivacyConsentOperation };